// Module
var code = "<div><button class=\"btn btn-lg btn-black\" ng-click=$ctrl.createProposal()>Create Proposal</button></div>";
// Exports
module.exports = code;